import { render, staticRenderFns } from "./coderOutpatientPxs.vue?vue&type=template&id=0c4a0340&scoped=true&"
import script from "./coderOutpatientPxs.vue?vue&type=script&lang=js&"
export * from "./coderOutpatientPxs.vue?vue&type=script&lang=js&"
import style0 from "./coderOutpatientPxs.vue?vue&type=style&index=0&id=0c4a0340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a0340",
  null
  
)

export default component.exports